import styled from 'styled-components/macro';

export const InfoWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const InfoIcon = styled.span({
  display: 'block',
  width: '32px',
  height: '32px',
  marginRight: '10px',
  flexShrink: 0,
});
